const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_ID || 'ud6x47m5sn';

export const getIOSVersion = () => {
  const match = navigator.userAgent.match(/OS (\d+)[._](\d+)?/);
  if (!match) {
    return null;
  }
  return {
    major: parseInt(match[1], 10),
    minor: parseInt(match[2] || '0', 10),
  };
};

/**
 * Clarity web não é compatível com iOS 12.x (Safari antigo / PWA legado).
 * O SDK nativo da Microsoft exige iOS 15+.
 */
export const supportsClarityWeb = () => {
  const ios = getIOSVersion();
  if (ios && ios.major < 13) {
    return false;
  }
  return true;
};

const loadClarityScript = (projectId) => {
  if (window.clarity) {
    return;
  }
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', projectId);
};

/**
 * Beacon simples (GET via Image) — funciona no iOS 12.5 quando Clarity não grava.
 * Configure REACT_APP_ANALYTICS_FALLBACK_URL apontando para seu endpoint (GA Measurement Protocol,
 * webhook Make/Zapier, API própria, etc.).
 */
export const sendLegacyAnalyticsBeacon = (eventName, extra = {}) => {
  const baseUrl = process.env.REACT_APP_ANALYTICS_FALLBACK_URL;
  if (!baseUrl || process.env.NODE_ENV !== 'production') {
    return;
  }

  const ios = getIOSVersion();
  const params = new URLSearchParams({
    e: eventName,
    u: window.location.pathname + window.location.search,
    r: document.referrer || '',
    t: String(Date.now()),
    ios: ios ? `${ios.major}.${ios.minor}` : 'na',
    standalone: String(window.navigator.standalone === true),
    ...extra,
  });

  const separator = baseUrl.includes('?') ? '&' : '?';
  const img = new Image(1, 1);
  img.src = `${baseUrl}${separator}${params.toString()}`;
};

export const initAnalytics = () => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  if (supportsClarityWeb()) {
    loadClarityScript(CLARITY_PROJECT_ID);
    return;
  }

  sendLegacyAnalyticsBeacon('pageview', { reason: 'clarity-unsupported-ios' });
};

export const trackPageView = (pathname) => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  if (supportsClarityWeb()) {
    if (typeof window.clarity === 'function') {
      window.clarity('set', 'page', pathname);
    }
    return;
  }

  sendLegacyAnalyticsBeacon('pageview', { path: pathname });
};

export const trackEvent = (eventName, extra = {}) => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  if (supportsClarityWeb()) {
    if (typeof window.clarity === 'function') {
      window.clarity('event', eventName);
    }
    return;
  }

  sendLegacyAnalyticsBeacon(eventName, extra);
};
